<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none" class="section-separator bottom has-background-white" ><path :transform="transform" d="M100 0 L100 100 L0 0 Z"></path></svg>
</template>

<script>
export default {
  props:["transform"]
}
</script>
